import './table-of-contents.scss';
import './table-of-contents-filter.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSTableOfContents } from './table-of-contents';
import { GSTableOfContentsFilter } from './table-of-contents-filter';

components.register({
	selector: '.gs-TableOfContents',
	controller: GSTableOfContents
});

components.register({
	selector: '.gs-TableOfContentsFilter',
	controller: GSTableOfContentsFilter
});
